module.exports = "/_next/static/images/Product-Management-9dc52e5fad72a73dfb7edf34916c942c.jpg";